<template>
  <Splash class="Games">
    <!-- <Overlay slot="overlay"></Overlay> -->

    <template slot="header">
      <h1>Games</h1>
    </template>

    <template slot="caption">
      When replays are uploaded to WC3Stats, they will automatically be added to this list.
    </template>

    <template slot="content">
      <GameDirectory></GameDirectory>
    </template>
  </Splash>
</template>

<script>
  import Splash from '@/legacy/components/layout/Splash';
  import Overlay from '@/legacy/components/widgets/Overlay';
  import GameDirectory from '@/legacy/components/GameDirectory';
  import { metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: 'Games',
        description: 'Browse and search a real-time games directory for every Warcraft III replay ever uploaded.'
      })
    },

    components: {
      Splash,
      Overlay,
      GameDirectory
    }
  };
</script>

<style lang="scss">
  .Games {
    // Other
    background:
      asset('background/home.jpg')               no-repeat,
      asset('background/home-repeat.jpg') center repeat-y;
  }
</style>